exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user.component {\n  font-size: 0.9em;\n  box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  padding: 30px 30px 12px 30px;\n}\n\n.user.component > * {\n  margin: 6px;\n  color: #FFFFFF;\n}\n\n.user.component .menu-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.user.component .menu-wrapper button {\n  padding: 0;\n  background: none;\n  margin: 0;\n  margin-right: 6px;\n}\n\n\n.user.component .menu-wrapper button:last-of-type {\n  margin-right: 0;\n}\n\n.user.component > a > img {\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.user.component select{\n  height: 32px;\n  color: #000000;\n  box-sizing: border-box;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/user/user.css
// module id = 499
// module chunks = 0